<template>
  <div class="orderDetails orderNew evaluate-style">
    <div class="title">订单评价</div>
    <div class="order-no">
      <span>订单编号</span>
      <span class="val">{{info.orderNo}}</span>
    </div>
    <div class="evaluate-content">
      <div class="left">
        <img :src="info.mainPic" alt="">
        <p class="name">{{info.goodsName}}</p>
        <p class="price">￥{{info.paymentTotal}}</p>
      </div>
      <div class="right">
        <div class="module">
          <p class="sub-title">整体评分</p>
          <el-rate v-model="score"></el-rate>
          <p class="grade">{{score}}分</p>
        </div>
        <div class="describe">
          <el-input
            type="textarea"
            :rows="4"
            placeholder="分享体验心得，给万千想买的人一个参考（最少输入10字）"
            v-model="content"
            maxlength="500"
            @input="handleInput"
            >
          </el-input>
          <span class="count">{{ textCount }}/500</span>
        </div>
        <div class="pic-list">
          <el-upload
            class="upload-img"
            :class="picList.length >= 9 ? 'exceed' : ''"
            :show-file-list="true"
            list-type="picture-card"
            :http-request="handleUploadImg"
            action=""
            :limit="9"
            :before-upload="beforeAvatarUpload"
            :on-preview="handlePicPreview"
            :on-remove="handlePicRemove"
          >
            <img src="@/assets/images/camera.png" alt="">
            <span>电脑传图</span>
            <p class="count-text">共<span class="c-o">{{picList.length}}</span>张，还能上传<span class="c-o">{{9-picList.length}}</span>张</p>
          </el-upload>
        </div>
      </div>
    </div>
    <div class="submit-btn">
      <div @click="handleSubmit">提交</div>
    </div>
    <el-dialog width="50%" :visible.sync="dialogImgVisible" :append-to-body="true">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
import fetch from '@/utils/fetch'
import { saveReview } from '@/api/myOrder'
import { config } from '@/constant/config'
export default {
  name: 'OrderEvaluate',
  data () {
    return {
      moduleType: 'FOOD',
      info: {},
      score: 0,
      content: '',
      textCount: 0,
      picList: [],
      dialogImgVisible: false,
      dialogImageUrl: ''
    }
  },
  created () {
    this.info = JSON.parse(this.$route.query.info)
    this.moduleType = this.$route.query.moduleType
  },
  methods: {
    // 提交
    handleSubmit () {
      if (this.score === 0) {
        this.$message.warning('请点击评分')
        return
      }
      if (this.content.trim() === '') {
        this.$message.warning('请输入评价内容')
        return
      }
      if (this.content.trim().length < 10) {
        this.$message.warning('评价内容最少输入十个字')
        return
      }
      let pictures = []
      if (this.picList.length > 0) {
        this.picList.forEach((item, index) => {
          pictures.push({
            index: index + 1,
            url: item.link
          })
        })
        pictures = JSON.stringify(pictures)
      } else {
        pictures = null
      }
      const data = {
        tenantId: config.TENANTID,
        merchId: config.MERCHID,
        merchIndustryId: this.info.merchIndustryId,
        merchIndustryName: this.info.merchIndustryName,
        moduleType: this.moduleType,
        goodsId: this.info.goodsId,
        goodsName: this.info.goodsName,
        orderNo: this.info.orderNo,
        pictures,
        content: this.content,
        score: this.score
      }
      saveReview(data).then(res => {
        if (res.code === 0) {
          this.$message.success('已提交评价')
          this.$router.go(-1)
        } else {
          this.$message.error(res.error)
        }
      })
    },
    // 删除图片
    handlePicRemove (file) {
      this.picList = this.picList.filter(item => item.uid !== file.uid)
    },
    handlePicPreview (file) {
      const obj = this.picList.find(item => item.uid === file.uid)
      if (obj) {
        this.dialogImageUrl = obj.link
        this.dialogImgVisible = true
      }
    },
    // 上传图片
    handleUploadImg (arg) {
      const data = new FormData()
      data.append('file', arg.file)
      data.append('isOpen', 'T')
      fetch({
        url: '/oss/endpoint/put-img',
        method: 'post',
        data
      }).then(res => {
        if (res.code === 0) {
          this.picList.push({
            uid: arg.file.uid,
            link: res.data.link
          })
        } else {
          this.$message.error(res.error)
        }
      })
    },
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/gif' || file.type === 'image/webp'
      if (!isJPG) {
        this.$message.warning('请上传图片')
      }
      return isJPG
    },
    handleInput () {
      this.textCount = this.content.length
    }
  }
}
</script>
<style lang="scss">
.evaluate-style{
  padding: 40px;
  .title{
    font-size: 24px;
    font-weight: bold;
    line-height: 36px;
    color: #9B232A;
    margin-bottom: 20px;
  }
  .order-no {
    padding-bottom: 20px;
    border-bottom: 1px solid #8FA8BC;
    opacity: 0.5;
    font-size: 16px;
    color: #9FA1B0;
    .val {
      color: #44516F;
      margin-left: 30px;
    }
  }
  .evaluate-content {
    padding: 40px 0;
    display: flex;
    .left {
      text-align: center;
      width: 160px;
      img {
        width: 160px;
        height: 160px;
      }
      .name {
        font-size: 14px;
        color: #242B34;
        margin-top: 8px;
        line-height: 20px;
      }
      .price {
        font-size: 16px;
        font-weight: bold;
        color: #1D263A;
        margin-top: 8px;
      }
    }
    .right {
      margin-left: 24px;
      flex: 1;
      .module {
        display: flex;
        align-items: center;
        .el-rate {
          height: 30px;
        }
        .el-rate__icon {
          font-size: 28px;
        }
        .sub-title {
          width: 72px;
          font-size: 18px;
          font-weight: bold;
          color: #242B34;
          margin-right: 12px;
        }
        .grade {
          font-size: 18px;
          font-weight: bold;
          color: #FF0000;
          margin-left: 12px;
        }
      }
      .describe {
        margin-top: 20px;
        position: relative;
        .count {
          position: absolute;
          bottom: 8px;
          right: 12px;
          font-size: 12px;
          color: #9FA1B0;
        }
      }
      .pic-list {
        margin-top: 12px;
        display: flex;
        align-items: flex-end;
        >img {
          width: 80px;
          height: 80px;
          margin: 12px 0 0 12px;
          vertical-align: bottom;
        }
      }
      .upload-img {
        max-width: 720px;
        &.exceed {
          .el-upload {
            display: none;
          }
        }
        .el-upload-list--picture-card .el-upload-list__item{
          border: none;
          width: 80px;
          height: 80px;
          margin: 0 12px 8px 0;
        }
        .el-upload--picture-card:hover, .el-upload:focus {
          border-color: unset;
          color: unset;
        }
        .el-upload--picture-card {
          display: inline-flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          line-height: unset;
          min-width: 80px;
          max-width: 80px;
          height: 80px;
          position: relative;
          background: #F7F9FD;
          border-radius: 4px;
          border: none;
          img {
            width: 48px;
            height: 48px;
          }
          >span {
            font-size: 12px;
            color: #95A3AF;
          }
          .count-text {
            position: absolute;
            left: 92px;
            bottom: 0;
            width: unset;
            white-space: nowrap;
            font-size: 14px;
            color: #95A3AF;
            .c-o{
              color: #FF0000;
            }
          }
        }
      }
    }
  }
  .submit-btn {
    cursor: pointer;
    margin-top: 60px;
    div {
      float: right;
      width: 140px;
      height: 44px;
      background: #9B232A;
      border-radius: 4px;
      line-height: 44px;
      text-align: center;
      font-size: 16px;
      font-weight: bold;
      color: #FFFFFF;
    }
  }
}
</style>
